import { render, staticRenderFns } from "./C2D.vue?vue&type=template&id=235b5016&scoped=true"
import script from "./C2D.vue?vue&type=script&lang=js"
export * from "./C2D.vue?vue&type=script&lang=js"
import style0 from "./C2D.vue?vue&type=style&index=0&id=235b5016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b5016",
  null
  
)

export default component.exports